import React from 'react';

const baseTypographyStyle: React.CSSProperties = {
  fontFamily: 'Interstate',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.6px',
};

interface DialogTitleProps {
  children: React.ReactNode;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  centered?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const DialogTitle: React.FC<DialogTitleProps> = ({
  children,
  color = '#63615C',
  size = 'md',
  centered = false,
  className,
  style,
}) => {
  const fontSize = {
    sm: '14px',
    md: '16px',
    lg: '20px',
  }[size];

  const fontWeight = size === 'lg' ? 800 : 600;

  return (
    <div
      className={className}
      style={{
        ...baseTypographyStyle,
        color,
        fontSize,
        fontWeight,
        textAlign: centered ? 'center' : 'left',
        marginBottom: '12px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

interface DialogTextProps {
  children: React.ReactNode;
  color?: string;
  size?: 'xs' | 'sm' | 'md';
  weight?: 400 | 500 | 600;
  centered?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const DialogText: React.FC<DialogTextProps> = ({
  children,
  color = '#63615C',
  size = 'sm',
  weight = 500,
  centered = false,
  className,
  style,
}) => {
  const fontSize = {
    xs: '12px',
    sm: '14px',
    md: '16px',
  }[size];

  return (
    <div
      className={className}
      style={{
        ...baseTypographyStyle,
        color,
        fontSize,
        fontWeight: weight,
        textAlign: centered ? 'center' : 'left',
        marginBottom: '12px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
